import { render, staticRenderFns } from "./PlantInfoDialog.vue?vue&type=template&id=4e491485&scoped=true&"
import script from "./PlantInfoDialog.vue?vue&type=script&lang=js&"
export * from "./PlantInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./PlantInfoDialog.vue?vue&type=style&index=0&id=4e491485&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e491485",
  null
  
)

export default component.exports